<template>
  <base-window-list
    :headers="headers"
    title="Listado de Sedes"
    :company="comdes"
    addMethod="itemsSedes"
    closeBaseWindow='addSedes'
    titleAddMethod="Agregar Sede"
    itemStoreName="itemsSedes"
    :loading="loadingResult"
    :activarEdicion="true"
    :activarBorrar="true"
    :activarInternalForm="true"
    :formProperties="{
      creacion: 'Creacion de Sede',
      edicion: 'Editar Sede',
      url: `/transjuma/Sede/`
    }"
    v-on:selected-row="handleEvent"
    v-on:updated="updatedList"
  ></base-window-list>
</template>

<script>
import { mapState } from 'vuex'
import BaseWindowList from '@/components/BaseWindowListGeneral'
import { paginationMethods } from '@/mixins/pagination'
export default {
  components:{
    BaseWindowList
  },
  mixins: [paginationMethods],
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          colmd: 4,
          form: false,
          require: true,
          vtext: true,
        },
        {
          text: 'Nombre',
          align: 'center',
          value: 'nombre',
          colmd: 12,
          form: true,
          require: true,
          vtext: true,
        },
        {
          text: 'Dirección',
          align: 'center',
          value: 'direccion',
          colmd: 12,
          form: true,
          require: true,
          vtext: true,
        },
        {
          text: 'Telefono',
          align: 'center',
          value: 'telefono',
          colmd: 12,
          form: true,
          require: true,
          vtext: true,
        },
        {
          text: 'Contacto',
          align: 'center',
          value: 'contacto',
          form: true,
          require: false,
          vtext: true,
        },
        {
          text: 'Acciones',
          align: 'center',
          value: 'actions',
          require: true,
        },
      ],
      loadingResult: true
    }
  },
  computed:{
    ...mapState([
      'addSedes',
    ]),
    company(){
      return this.$store.state.AuthModule.refu
    },
    comdes(){
      return 'Transjuma'
    }
  },
  methods: {
    handleEvent(item) {
      this.$emit('Sedes-selected', item)
    },
    updatedList(){
      this.getData()
    },
    async getData(){
      await this.$store.dispatch('AuthModule/verifyToken')
      console.log('BUSCANDO LOS DATOS')
      const obj = {
        token : this.$store.state.AuthModule.accessToken,
        method: 'GET',
        url: 'transjuma/Sede/',
        // body: body
        params:{
          ids: 1
        }
      }
      // this.loadingTable = true
      this.$store.dispatch('fechData', obj)
        .then((result) => {
          this.$store.dispatch('actItemsBaseWindowsList',{data: result, nombre: 'itemsSedes'})
          this.loadingResult = false
        })
        .catch((err) => {
          const regex = /["[{\]}]/g
          const mensaje = JSON.stringify(err.response.data).replaceAll(regex,'') ?? ''
          this.showAlert('error', mensaje)
          this.loadingResult = false
          if (err.response.status == 401){
            alert(
              `token no valido o vencido:  ${err.response.data.detail ?? ''}`
            )
            this.$router.push({name: 'LoginView'})
          }
        })
    }
  },
  created() {
    this.$store.state.itemsSedes = []
    this.getData()
  }
}
</script>

<style>

</style>